/**
 * Client manifest holding environement variable mapping and defaults
 * Defaults are for development environment to prevent exposure and easier localhost development
 */

/* eslint-disable prefer-destructuring */
const BUILD_ENV = process.env.BUILD_ENV;
export const NODE_ENV = process.env.NODE_ENV;
/* eslint-enable prefer-destructuring */

export const ENV = {
  ...(BUILD_ENV || {}),
  ...window.zdInit
};

export const {
  DEPLOY_ENV,
  IS_PROD,
  IS_DEV,
  ROUTES,
  RELEASE_VERSION,
  DEFAULT_ROUTE,
  DEFAULT_SEGMENT,
  LOGIN_PATH,
  USE_STRICTMODE,
  GRAPHQL_ROUTE,
  FEDERATED
} = ENV;

const environment = ENV.DEPLOY_ENV;
const release = ENV.RELEASE_VERSION;

if (typeof window.process === 'undefined') {
  window.process = {
    env: ENV
  };
}

export const generateRedirectDict = ({ businessEntityUuid }) => ({
  money: {
    relativeRedirectPath: `/d/company/${businessEntityUuid}/money`
  },
  'zenbusiness-banking': {
    relativeRedirectPath: `/d/b/${businessEntityUuid}/dashboard`
  }
});

export const CLIENTS = {
  sentry: {
    enabled: ENV.SENTRY_ENABLED,
    slug: 'https://sentry.io/organizations/zenbusiness-pbc/',
    options: {
      dsn: ENV.SENTRY_DSN,
      environment,
      release
    }
  },
  filestack: {
    key: ENV.FILESTACK_PUBLIC_KEY,
    storageEngine: ENV.FILESTACK_STORAGE_ENGINE || 'gcs'
  },
  stripe: {
    key: ENV.STRIPE_PUBLISH_KEY
  },
  mixpanel: {
    token: ENV.MIXPANEL_TOKEN,
    options: {}
  },
  google: {
    enabled: ENV.GOOGLE_ENABLED,
    adWordsToken: ENV.GOOGLE_ADWORDS_TOKEN
  },
  intercom: {
    enabled: ENV.INTERCOM_ENABLED,
    appId: ENV.INTERCOM_APPID,
    productTourId: ENV.INTERCOM_PRODUCT_TOUR_ID
  },
  auth0: {
    domain: ENV.AUTH0_DOMAIN,
    clientID: ENV.AUTH0_CLIENTID,
    audience: ENV.AUTH0_AUDIENCE
  },
  profitwell: {
    enabled: ENV.PROFITWELL_ENABLED,
    token: ENV.PROFITWELL_PUBLIC_TOKEN,
    options: {}
  },
  hellosign: {
    clientId: ENV.HELLO_SIGN_CLIENT_ID,
    skipDomainVerification: ENV.HELLO_SIGN_SKIP_DOMAIN_VERIFY
  }
};

export const ANALYTICS = {
  rudderstack: {
    apiKey: ENV.RUDDERSTACK_API_KEY,
    url: ENV.RUDDERSTACK_API_URL
  }
};

const featureOverrides = {};

if (environment !== 'production') {
  const search = new URLSearchParams(window.location.search);
  // Only allow boolean value overrides in dev/local
  search.forEach((val, key) => {
    const strVal = val.toLowerCase();
    if (['true', 'false'].includes(strVal)) {
      featureOverrides[key] = strVal === 'true';
    }
  });
}

export const FEATURES = {
  sessionStorageEnabled: ENV.SESSION_STORAGE_ENABLED,
  businessCardOfferUrl: ENV.BUSINESS_CARD_OFFER_URL,
  ...featureOverrides // only allow feature flags this way in dev/local
};

export default {
  environment,
  release,
  analytics: ANALYTICS,
  clients: CLIENTS,
  features: FEATURES,
  contactHours: 'Monday \u2013 Friday from 8am \u2013 8pm and Sunday from 9am \u2013 6pm Central\u00A0Time',
  ignoreRedirectTo: ['/', '/d', '/d/logout', '/d/login', '/d/callback'],
  fintech: {
    merchantOnboardingRequireFormationComplete: 'MERCHANT_ONBOARDING_REQUIRE_FORMATION_COMPLETE' in ENV ? ENV.MERCHANT_ONBOARDING_REQUIRE_FORMATION_COMPLETE : true,
    merchantOnboardingPath: ENV.MERCHANT_ONBOARDING_PATH,
    hurdlrWebSdkStableScriptSrc: 'https://cdn.hurdlr.com/sdk/stable/hurdlr.js',
    invoiceCTAShowAfterFormationDate: null // null when it is not used or date like 'June 11 2022',
  }
};
